import type { ButtonHTMLAttributes, ReactNode } from "react";

export type ButtonVariant = "ghost" | "gold" | "danger";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  fullWidth?: boolean;
  children?: ReactNode;
}

export function Button({
  variant = "ghost",
  fullWidth = false,
  className,
  style,
  children,
  ...rest
}: ButtonProps) {
  const cls = [
    "vb-btn",
    variant === "gold" ? "vb-btn-gold" : null,
    variant === "danger" ? "vb-btn-danger" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const mergedStyle = fullWidth ? { width: "100%", ...style } : style;
  return (
    <button className={cls} style={mergedStyle} {...rest}>
      {children}
    </button>
  );
}
